import { MenuItem } from '../types';

export const menuItems: MenuItem[] = [
  {
    label: 'Free Tools',
    href: '/free-tools'
  },
  {
    label: 'Hire Me',
    href: '/services'
  },
  {
    label: 'Blog',
    href: 'https://blog.cemates.me',
    external: true
  }
];
